import React, { Component } from "react";
import request from "superagent";
import { url_endpoint, url_s3, urlPlayer } from "../../config";
import authHeader from "../Utils/AuthHeader";
import { flexbox, height } from "@material-ui/system";
import {
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Select,
  FilledInput,
} from "@material-ui/core";
import ButtonLogout from "../../componentes/ButtonLogout";
import LoaderSpinner from "../../componentes/LoaderSpinner";

import {
  Grid,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import clone from "lodash/cloneDeep";
import checkLogin from "../Utils/checkLogin";

const useStyles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: "left",
    color: theme.palette.text.secondary,
    boxShadow: "none",
  },
});

class Podcast extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dados: [],
      dadosCache: [],
      clientes: [],
      id_editar: -1,
      filter: (_) => true,
      insert: {
        titulo: "",
        audio: 0,
        img: 0,
        ClienteId: -1,
        url_post_spotify: "",
        url_post_itunes: "",
        url_post_google: "",
        agregar: false,
      },
      loading: false,
      openModalEdit: false,
      postcastViewEdit: {},
      windowHeight: 0,
      iframeSize: "180px",
      actualPage: 0,
      minutos: 0
    };
    this.status = [
      { label: "Aguardando", color: "#cb8915" },
      { label: "Rejeitado", color: "rgb(191, 0, 22)" },
      { label: "Aprovado", color: "#00a219" },
      { label: "Excluido", color: "#5a5a5a" },
    ];
  }

  async excluir(id) {
    if (!window.confirm("Você tem certeza que deseja deletar este item?"))
      return;
    try {
      this.setState({ loading: true });
      await request.delete(url_endpoint + "podcast/" + id).set(authHeader());
      this.setState({ loading: false });

      const dados = this.state.dados;
      dados.splice(
        dados.findIndex((i) => i.id === id),
        1
      );

      this.setState({ dados, dadosCache: dados });
    } catch (err) {
      this.setState({ loading: false });
      alert(err.response.text);
    }
  }
  inserir_editar = async () => {
    try {
      this.setState({ loading: true });

      let method = "post";
      let url_plus = "";
      if (this.state.id_editar >= 0) {
        method = "put";
        url_plus = "/" + this.state.id_editar;
      }

      const res = await request(method, url_endpoint + "podcast" + url_plus)
        .set(authHeader())
        .attach("audio", this.state.insert.audio)
        .attach("foto", this.state.insert.img)
        .field("titulo", this.state.insert.titulo)
        .field("url_post_itunes", this.state.insert.url_post_itunes)
        .field("url_post_google", this.state.insert.url_post_google)
        .field("url_post_spotify", this.state.insert.url_post_spotify)
        .field("descricao", this.state.insert.descricao)
        .field("ClienteId", this.state.insert.ClienteId)
        .field('minutos', this.state.insert.minutos);

      this.handleClose();
      this.setState({ loading: false });

      const dados = this.state.dados;
      res.body.Cliente = this.state.insert.Cliente;

      if (this.state.id_editar >= 0) {
        dados[dados.findIndex((item) => item.id === this.state.id_editar)] =
          res.body;
      } else {
        dados.push(res.body);
      }
      this.setState({ dadosCache: dados });
      this.setState({
        dados,
        id_editar: -1,
        insert: {
          titulo: "",
          audio: 0,
          img: 0,
          url_post_spotify: "",
          url_post_itunes: "",
          url_post_google: "",
          descricao: "",
        },
        postcastViewEdit: {},
      });
    } catch (err) {
      this.setState({ loading: false });
      alert(err);
    }
  };
  changeField = (field, value) => {
    const insert = this.state.insert;
    insert[field] = value.target.value;
    this.setState({ insert });
  };
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  async componentDidMount() {
    try {
      await checkLogin(true)
      window.scrollTo(0, 0);
      this.handleResize();
      window.addEventListener("resize", this.handleResize);
      this.setState({ loading: true });

      const res = await request.get(url_endpoint + "podcast/page/" + this.state.actualPage).set(authHeader());

      const res_cliente = await request
        .get(url_endpoint + "cliente/all")
        .set(authHeader());
      this.setState({ loading: false });

      this.setState({
        dados: res.body,
        dadosCache: res.body,
        clientes: res_cliente.body,
      });
    } catch (e) {
      this.setState({ loading: false });
      alert(e);
    }
  }
  setAudio = (evt) => {
    const insert = this.state.insert;
    insert.audio = evt.target.files[0];
    const durationAudio = new Audio()
    durationAudio.onloadedmetadata = evt => {
      insert.minutos = Math.round(durationAudio.duration)
      this.setState({ insert });
    }
    durationAudio.src = URL.createObjectURL(insert.audio)
  };

  setImg = (evt) => {
    const insert = this.state.insert;
    insert.img = evt.target.files[0];
    this.setState({ insert });
  };

  editar = (item) => {
    const insert = this.state.insert;
    //console.log(item);
    insert.titulo = item.titulo;
    insert.agregar = item.agregar;
    insert.minutos = item.minutos

    insert.url_post_spotify = item.url_post_spotify
      ? item.url_post_spotify
      : "";
    insert.url_post_itunes = item.url_post_itunes ? item.url_post_itunes : "";
    insert.url_post_google = item.url_post_google ? item.url_post_google : "";
    insert.descricao = item.descricao ? item.descricao : "";

    insert.ClienteId = item.ClienteId;
    insert.Cliente = item.Cliente;

    const iframeSize =
      parseInt(item.Cliente.layout) === 3 ? "122px;" : "180px;";

    this.setState({
      openModalEdit: true,
      postcastViewEdit: clone(item),
      iframeSize: iframeSize,
    });
    this.setState({ insert, id_editar: item.id });
  };

  handleFilterClient = async (evt) => {
    this.setState({ dados: [] });

    const value = parseInt(evt.target.value);
    if (parseInt(value) === -1) {
      this.setState({ dados: this.state.dadosCache });
    } else {
      const res = await request.get(url_endpoint + "podcast/podcastByClient/" + value).set(authHeader());
      this.setState({ dados: res.body });
    }
  };

  changeFilterStatus = (evt) => {
    const value = evt.target.value;
    if (parseInt(value) === -1) this.setState({ filter: (_) => true });
    else this.setState({ filter: (evt) => evt.status === parseInt(value) });
  };

  handleResize = () =>
    this.setState({
      windowHeight: window.innerHeight,
    });
  handleClose = () => {
    this.setState({ openModalEdit: false });
  };

  nextPage = async () => {
    this.setState({ loading: true })
    const lastPage = this.state.actualPage
    const newPage = lastPage + 1
    const res = await request.get(url_endpoint + "podcast/page/" + newPage).set(authHeader());
    if (res.body.length > 0) {
      this.setState({ loading: false, dados: res.body, actualPage: newPage })
    }
    else {
      this.setState({ loading: false })
      window.alert('Já está na última página.')
    }
  }

  prevPage = async () => {
    const lastPage = this.state.actualPage
    const newPage = lastPage - 1
    if (newPage < 0) {
      window.alert('Já está na primeira página')
    }
    else {
      this.setState({ loading: true, actualPage: newPage })
      const res = await request.get(url_endpoint + "podcast/page/" + newPage).set(authHeader());
      this.setState({ loading: false, dados: res.body })
    }
  }

  downloadAudio = (url) => {
    //console.log(url)
    window.open(url)
  }

  render() {
    const insert = this.state.insert;
    const intFrameHeight = this.state.windowHeight - 42 + "px";
    const { classes } = this.props;
    return (
      <div style={{ height: intFrameHeight, overflow: "auto" }}>
        {this.state.loading && <LoaderSpinner />}

        <div className={"button-logout"}>
          <IconButton>
            <ButtonLogout />
          </IconButton>
        </div>

        <Dialog
          open={this.state.openModalEdit}
          fullWidth={true}
          maxWidth={"xl"}
          onClose={this.handleClose}
          aria-labelledby="draggable-dialog-title"
        >
          <DialogTitle>{"Edição do Áudio"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <div style={{ display: "flex" }}>
                <div className={"insert"} style={{ width: "38%" }}>
                  <div className={"input_edit"}>
                    <b>Título: </b>
                    <TextField
                      placeholder={"Título"}
                      value={insert.titulo}
                      onChange={(evt) => this.changeField("titulo", evt)}
                    />
                  </div>

                  <div className={"input_edit"}>
                    <b>Áudio: </b>
                    <input
                      type={"file"}
                      accept={'audio/mp3'}
                      onChange={(evt) => {

                        this.setAudio(evt)
                      }}
                    />
                  </div>

                  <div className={"input_edit"}>
                    <b>Imagem: </b>
                    <input type={"file"} onChange={(evt) => this.setImg(evt)} />
                  </div>

                  <div className={"input_edit"}>
                    <b>Cliente: </b>
                    <Select
                      value={insert.ClienteId}
                      onChange={(evt) => this.changeField("ClienteId", evt)}
                    >
                      <MenuItem value={-1} disabled selected>
                        Selecione
                      </MenuItem>
                      {this.state.clientes.map((item) => {
                        return <MenuItem value={item.id}>{item.nome}</MenuItem>;
                      })}
                    </Select>
                  </div>
                  <div className={"input_edit"}>
                    <b>URL Spotify: </b>
                    <TextField
                      className={"input_edit"}
                      placeholder={"URL Spotify"}
                      value={insert.url_post_spotify}
                      onChange={(evt) =>
                        this.changeField("url_post_spotify", evt)
                      }
                    />
                    <br />
                  </div>

                  <div className={"input_edit"}>
                    <b>URL Itunes: </b>
                    <TextField
                      className={"input_edit"}
                      placeholder={"URL Itunes"}
                      value={insert.url_post_itunes}
                      onChange={(evt) =>
                        this.changeField("url_post_itunes", evt)
                      }
                    />
                    <br />
                  </div>
                  <div className={"input_edit"}>
                    <b>URL Google: </b>
                    <TextField
                      className={"input_edit"}
                      placeholder={"URL Cast"}
                      value={insert.url_post_google}
                      onChange={(evt) =>
                        this.changeField("url_post_google", evt)
                      }
                    />
                    <br />
                  </div>

                  <div className={"input_edit"}>
                    <b>Descrição: </b>

                    <TextField
                      multiline
                      className={"input_edit"}
                      rowsMax="10"
                      defaultValue={insert.descricao}
                      value={insert.descricao}
                      placeholder="Descricao"
                      onChange={(evt) => this.changeField("descricao", evt)}
                    />
                  </div>

                  <div className={"input_edit"}>
                    <b>Minutos: </b>

                    <input
                      type="number"
                      value={insert.minutos}
                      readOnly
                    ></input>
                  </div>

                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.inserir_editar}
                  >
                    {this.state.id_editar == -1 ? (
                      <span>Salvar</span>
                    ) : (
                      <span>Salvar edição</span>
                    )}{" "}
                  </Button>
                  <br />
                  <br />
                </div>
              </div>
              <h2>{"Informações do Postcast"}</h2>

              <div className={classes.root}>
                <Grid container spacing={3}>
                  <Grid item xs>
                    <Paper className={classes.paper}>
                      {"Integração"}
                      <textarea
                        readOnly
                        style={{ height: "auto", width: "100%" }}
                      >
                        {"<iframe src='" +
                          urlPlayer +
                          "/player/" +
                          this.state.postcastViewEdit.id +
                          "' style='height:" +
                          this.state.iframeSize +
                          " min-width: 320px; width: 100%; border:none;'></iframe>"}
                      </textarea>
                    </Paper>
                  </Grid>
                  <Grid item xs>
                    <Paper className={classes.paper}>
                      {"Observações"}
                      <textarea
                        readOnly
                        style={{ height: "auto", width: "100%" }}
                      >
                        {this.state.postcastViewEdit.obs}
                      </textarea>
                    </Paper>
                  </Grid>

                  <Grid item xs>
                    <Paper className={classes.paper}>
                      {"Motivo"}
                      <textarea
                        readOnly
                        style={{ height: "auto", width: "100%" }}
                      >
                        {this.state.postcastViewEdit.motivo}
                      </textarea>
                    </Paper>
                  </Grid>

                  {this.state.postcastViewEdit.Pedido != null && (this.state.postcastViewEdit.Pedido.descricao_agregadores != null && this.state.postcastViewEdit.Pedido.descricao_agregadores != '') &&
                    <Grid item xs>
                      <Paper className={classes.paper}>
                        {"Descrição Agregadores"}
                        <textarea
                          readOnly
                          style={{ height: "auto", width: "100%" }}
                        >
                          {this.state.postcastViewEdit.Pedido.descricao_agregadores}
                        </textarea>
                      </Paper>
                    </Grid>
                  }
                </Grid>

                <Grid container spacing={3}>
                  <Grid item xs>
                    <Paper className={classes.paper}>
                      {"Itunes"}
                      <input
                        value={this.state.postcastViewEdit.url_post_itunes}
                        readOnly
                        style={{ width: "100%" }}
                      ></input>
                    </Paper>
                  </Grid>

                  <Grid item xs>
                    <Paper className={classes.paper}>
                      {"Google"}
                      <input
                        value={this.state.postcastViewEdit.url_post_google}
                        readOnly
                        style={{ width: "100%" }}
                      ></input>
                    </Paper>
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs>
                    <Paper className={classes.paper}>
                      {"Spotify"}
                      <input
                        value={this.state.postcastViewEdit.url_post_spotify}
                        readOnly
                        style={{ width: "100%" }}
                      ></input>
                    </Paper>
                  </Grid>

                  <Grid item xs>
                    <Paper className={classes.paper}>
                      {"RSS Fedd"}
                      <input
                        value={
                          this.state.postcastViewEdit.url_rssfeed
                            ? url_s3 + this.state.postcastViewEdit.url_rssfeed
                            : ""
                        }
                        readOnly
                        style={{ width: "100%" }}
                      ></input>
                    </Paper>
                  </Grid>
                </Grid>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={this.handleClose} color="primary">
              {"Fechar"}
            </Button>
          </DialogActions>
        </Dialog>

        <div style={{ textAlign: "center" }}>
          <select
            className={"combobox-filtro"}
            onChange={(evt) => this.handleFilterClient(evt)}
            value={this.state.id_client_filtro}
            width={200}
          >
            <option value={-1}>Filtro por Clientes</option>
            {this.state.clientes.map((item, x) => {
              return <option value={item.id}>{item.nome}</option>;
            })}
          </select>

          <select
            className={"combobox-filtro"}
            onChange={(evt) => this.changeFilterStatus(evt)}
            value={this.state.cod_filtro_status}
            width={200}
          >
            <option value={-1}>Filtro Status</option>
            <option value={0}>Aguardando</option>
            <option value={1}>Rejeitado</option>
            <option value={2}>Aprovado</option>
            <option value={3}>Excluido</option>
          </select>
        </div>

        <br />
        <h1>BlogPlay</h1>
        <br />
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '15px' }}>
          <button onClick={this.prevPage} style={{ marginRight: '10px' }}>Página Anterior</button>
          <button onClick={this.nextPage}>Próxima página</button>
        </div>
        <div
          className={"content_dados"}
          style={{ width: "100%", height: "100%" }}
        >
          <div style={{ overflow: "auto" }}>
            <table
              className={
                "custom-table custom-table-horizontal custom-table-highlight"
              }
            >
              <thead>
                <tr>
                  <th>Titulo</th>
                  <th>Cliente</th>
                  <th>Áudio</th>
                  <th>Data Pedido</th>
                  <th>Data Primeiro Envio</th>
                  <th>Data Última Atualização</th>
                  <th>Imagem</th>
                  <th>Status</th>
                  <th>Agregar</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {this.state.dados.filter(this.state.filter).map((item) => {
                  const datePedido = item.Pedido == null ? null : new Date(item.Pedido.createdAt)
                  const dateCreated = new Date(item.createdAt)
                  const dateUpdated = new Date(item.updatedAt)
                  return (
                    <tr>
                      <td>{item.titulo}</td>
                      <td>{item.Cliente.nome}</td>
                      <td width={200}>
                        {/* <audio controls>
                          <source src={url_s3 + item.arquivo} />
                        </audio> */}
                        {/* <a href={url_s3 + item.arquivo}>Baixar Áudio</a> */}
                        <button onClick={() => this.downloadAudio(item.arquivo.includes('digitalocean') ? item.arquivo : url_s3 + item.arquivo)}>Baixar Áudio</button>
                      </td>
                      <td width={150}>
                        <span>{datePedido == null ? '' : datePedido.getDate() + '/' + (datePedido.getMonth() + 1) + '/' + datePedido.getFullYear()}</span>
                      </td>
                      <td width={150}>
                        <span>{dateCreated.getDate() + '/' + (dateCreated.getMonth() + 1) + '/' + dateCreated.getFullYear()}</span>
                      </td>
                      <td width={150}>
                        <span>{dateUpdated.getDate() + '/' + (dateUpdated.getMonth() + 1) + '/' + dateUpdated.getFullYear()}</span>
                      </td>
                      <td width={100}>
                        <img src={item.imagem.includes('digitalocean') ? item.imagem : url_s3 + item.imagem} width={100} />
                      </td>
                      <td
                        style={{
                          background: this.status[item.status].color,
                          color: "#fff",
                          textAlign: "center",
                        }}
                      >
                        {this.status[item.status].label}
                      </td>

                      <td>{item.agregar ? "Agregar" : "Nao Agregar"}</td>
                      <td width={120}>
                        <button onClick={(_) => this.editar(item)}>
                          editar
                        </button>{" "}
                        |{" "}
                        <button onClick={(_) => this.excluir(item.id)}>
                          excluir
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(Podcast);
